import Firebase from '@/Firebase.js'

export default Firebase.firestore();